import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router.js'
import './plugins/ant-design-vue.js'
import './assets/css/global.css'
import 'ant-design-vue/dist/antd.css'
import axios from 'axios'
import navHead from './components/nav.vue'
import hljs from 'highlight.js'
import 'highlight.js/styles/default.css'
import cfg from '../config'
// 定义自定义指令 highlight 代码高亮
Vue.directive('highlight', function (el) {
  const blocks = el.querySelectorAll('pre code')
  blocks.forEach((block) => {
    hljs.highlightBlock(block)
  })
})
axios.defaults.baseURL = cfg.backend
// axios.defaults.baseURL = 'http://suan.sgidi.top'
axios.defaults.headers.common.Authorization = ''

axios.defaults.validateStatus = status => {
  return status < 500
}
axios.defaults.headers.common.Authorization = 'Bearer ' + localStorage.getItem('accessToken')
Vue.prototype.$http = axios

Vue.config.productionTip = false

Vue.component(navHead.name, navHead)
axios.interceptors.response.use(function (response) {
  if (response.status === 401) { router.push('/login') }
  return response
}, function (error) {
  return Promise.reject(error)
})

const vue = new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

axios.interceptors.response.use(function (response) {
  if (response.data.user_msg === undefined) { return response }
  const um = response.data.user_msg
  if (um.status === undefined || um.msg === undefined) { return response }
  switch (um.status) {
    case 'success':
      vue.$message.success(um.msg)
      break
    case 'info':
      vue.$message.info(um.msg, 4)
      break
    case 'warning':
      vue.$message.warning(um.msg, 6)
      break
    case 'error':
      vue.$message.error(um.msg, 6)
  }
  return response
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})
